import type { TenantAccessSummary, UserRole } from './db/types';

const adminRoles: UserRole[] = ['owner', 'manager', 'staff', 'coach'];
const billingActiveStates = new Set(['active', 'trialing']);

export function hasAdminAccess(roles: UserRole[]) {
  return roles.some((role) => adminRoles.includes(role));
}

export function hasMemberAccess(roles: UserRole[]) {
  return roles.includes('member');
}

export function tenantNeedsBillingAttention(tenant: TenantAccessSummary | null) {
  if (!tenant) return false;
  if (tenant.status !== 'active') return true;
  if (!tenant.billingStatus) return false;
  return !billingActiveStates.has(tenant.billingStatus);
}

export function tenantNeedsOnboarding(tenant: TenantAccessSummary | null, roles: UserRole[]) {
  if (!tenant) return false;
  if (!roles.includes('owner')) return false;
  if (tenantNeedsBillingAttention(tenant)) return false;
  return !!tenant.onboardingStatus && tenant.onboardingStatus !== 'complete';
}

export function defaultAuthenticatedPath(
  activeTenant: TenantAccessSummary | null,
  roles: UserRole[]
) {
  const admin = hasAdminAccess(roles);
  const member = hasMemberAccess(roles);

  if (!activeTenant) {
    return '/signup';
  }

  if (admin) {
    if (tenantNeedsBillingAttention(activeTenant)) {
      return '/checkout/cancelled';
    }

    if (tenantNeedsOnboarding(activeTenant, roles)) {
      return '/onboarding';
    }

    return '/dashboard';
  }

  if (member) {
    return '/member';
  }

  return '/signup';
}
